import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';

export default function RootRedirect() {
  const authenticated = isAuthenticated();
  
  return authenticated ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <Navigate to="/login" replace />
  );
}
